import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import appConstants from '../../constants';

import ContextProviderScreen from './ContextProvider/Screen';
import ContextProviderL18n from './ContextProvider/L18n';
import ContextProviderUser from './ContextProvider/User';
import ContextProviderNotifications from './ContextProvider/Notifications';
import ContextProviderPartnerSearch from './ContextProvider/Partner/Search';
import ContextProviderNavigationBetweenPartnerFeatures from './ContextProvider/Navigation/BetweenPartnerFeatures';
import ContextProviderNavigationBetweenSearchForms from './ContextProvider/Navigation/BetweenSearchForms';
import ContextProviderNavigationBetweenPartnerLists from './ContextProvider/Navigation/BetweenPartnerLists';
import PageHome from './Page/Home';
import PagePartnerProfile from './Page/PartnerProfile';
import PageNotFound from './Page/NotFound';
import NotificationPanel from './Notification/Panel';
import MasterHeader from './MasterHeader';
import MasterFooter from './MasterFooter';

export default function PartnerFinderApp() {

  return (
    <Router>
      <ContextProviderL18n>
        <ContextProviderScreen>
          <ContextProviderUser>
            <ContextProviderNotifications>
              <ContextProviderPartnerSearch>

                <ContextProviderNavigationBetweenPartnerFeatures>
                  <ContextProviderNavigationBetweenSearchForms>
                    <ContextProviderNavigationBetweenPartnerLists>
                      <div id="scrollableArea" className="min-w-cc-80 relative w-full h-full overflow-x-hidden">
                        <MasterHeader/>
                        <Switch>
                          <Route exact path={appConstants.APP_PAGE_HOME_ROUTE_PATH}>
                            <PageHome className="__MR_HOME__ shadow-cc-main-content"/>

                          </Route>
                          <Route exact path={appConstants.APP_PAGE_PARTNER_PROFILE_ROUTE_PATH}>
                            <PagePartnerProfile className="__MR_SEARCH__ shadow-cc-main-content"/>
                          </Route>
                          <Route path="*" component={PageNotFound}/>
                        </Switch>
                        <MasterFooter/>
                        <NotificationPanel/>
                      </div>

                    </ContextProviderNavigationBetweenPartnerLists>
                  </ContextProviderNavigationBetweenSearchForms>
                </ContextProviderNavigationBetweenPartnerFeatures>

              </ContextProviderPartnerSearch>
            </ContextProviderNotifications>
          </ContextProviderUser>
        </ContextProviderScreen>
      </ContextProviderL18n>
    </Router>
  );
}

